import { useLocalContext } from "../context/LocalContext"

export function Translate({keyLabel, children}) {
    const [{i18n}] = useLocalContext();
    if (keyLabel) {
        return i18n.getEntry(keyLabel);
    }

    return i18n.getEntry(children);
}